module.exports = __webpack_public_path__ + "static/img/zoom_btn4.28cdaaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/zoom_btn4.png
// module id = bMJ3
// module chunks = 4